export interface OrgTextCardTokens {
  cornerRadius: number;
  borderWidth: number;
  paddingX: number;
  nameFontSize: number;
  nameLineHeight: number;
  titleFontSize: number;
  titleLineHeight: number;
  gapBetweenNameAndTitle: number;
}

export const ORG_TEXT_CARD_TOKENS = {
  compact: {
    cornerRadius: 4,
    borderWidth: 1,
    paddingX: 12,
    nameFontSize: 12,
    nameLineHeight: 16,
    titleFontSize: 11,
    titleLineHeight: 13,
    gapBetweenNameAndTitle: 2,
  },
  full: {
    cornerRadius: 4,
    borderWidth: 0.6,
    paddingX: 16,
    nameFontSize: 14,
    nameLineHeight: 20,
    titleFontSize: 12,
    titleLineHeight: 16,
    gapBetweenNameAndTitle: 2,
  },
} satisfies { compact: OrgTextCardTokens; full: OrgTextCardTokens };

export const getOrgTextCardTokens = (isCompact: boolean): OrgTextCardTokens =>
  isCompact ? ORG_TEXT_CARD_TOKENS.compact : ORG_TEXT_CARD_TOKENS.full;
